import { SectionHeader } from '../components/SectionHeader'
import { NewsCard } from '../components/NewsCard'
import { NEWS_ITEMS } from '../../config/home.config'

export function NewsSection() {
  return (
    <section>
      <SectionHeader title="Tin Tức & Cẩm Nang" viewAllTo="/tin-tuc" />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        {NEWS_ITEMS.map((n) => (
          <NewsCard key={n.id} item={n} />
        ))}
      </div>
    </section>
  )
}
